import React from "react";
import PropTypes from "prop-types";

import { NavLink } from "react-router-dom";
import cx from "classnames";
import { connect } from 'react-redux';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";
import Icon from "@material-ui/core/Icon";
import Logout from "@material-ui/icons/MeetingRoom";
import User from "@material-ui/icons/Person";
import sidebarStyle from "../../assets/jss/views/sidebarStyle";
import { exit } from '../../stores/actions/actions';


// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {
    render() {
        const { className, user, headerLinks, links } = this.props;

        return (
            <div className={className} ref="sidebarWrapper" data-testid="sidebar">
                {user}
                {headerLinks}
                {links}
            </div>
        );
    }
}

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openAvatar: false,
            openComponents: this.activeRoute("/components"),
            openForms: this.activeRoute("/forms"),
            openTables: this.activeRoute("/tables"),
            openMaps: this.activeRoute("/maps"),
            openPages: this.activeRoute("-page"),
            miniActive: true
        };
        this.activeRoute.bind(this);
    }
    // verifies if routeName is the one active (in browser input)
    activeRoute(routeName) {
        const pathnameParts = this.props.location.pathname.split('/');
        return routeName === '/' + pathnameParts.pop() ? true : false;
    }
    openCollapse(collapse) {
        var st = {};
        st[collapse] = !this.state[collapse];
        this.setState(st);
    }
    render() {
        const {
            classes,
            color,
            image,
            routes,
            bgColor,
            rtlActive,
            systemId
        } = this.props;

        const itemText =
            classes.itemText +
            " " +
            cx({
                [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
                [classes.itemTextMiniRTL]:
                    rtlActive && this.props.miniActive && this.state.miniActive,
                [classes.itemTextRTL]: rtlActive
            });
        const collapseItemText =
            classes.collapseItemText +
            " " +
            cx({
                [classes.collapseItemTextMini]:
                    this.props.miniActive && this.state.miniActive,
                [classes.collapseItemTextMiniRTL]:
                    rtlActive && this.props.miniActive && this.state.miniActive,
                [classes.collapseItemTextRTL]: rtlActive
            });
        const userWrapperClass =
            classes.user +
            " " +
            cx({
                [classes.whiteAfter]: bgColor === "white"
            });
        const caret =
            classes.caret +
            " " +
            cx({
                [classes.caretRTL]: rtlActive
            });
        const collapseItemMini =
            classes.collapseItemMini +
            " " +
            cx({
                [classes.collapseItemMiniRTL]: rtlActive
            });
        const photo =
            classes.photo +
            " " +
            cx({
                [classes.photoRTL]: rtlActive
            });

        var user = (
            <div className={userWrapperClass} data-testid={this.state.miniActive ? "miniActiveTrue" : "miniActiveFalse"}>
                <div className={photo}>
                    {/* <img src={avatar} className={classes.avatarImg} alt="..." /> */}
                    <User />
                </div>
                <List className={classes.list}>
                    <ListItem className={classes.item + " " + classes.userItem}>
                        <NavLink
                            data-testid="UserMenu"
                            to={"#"}
                            className={classes.itemLink + " " + classes.userCollapseButton}
                            onClick={() => this.openCollapse("openAvatar")}
                        >
                            <ListItemText
                                primary={this.props.username}
                                secondary={
                                    <b
                                        className={
                                            caret +
                                            " " +
                                            classes.userCaret +
                                            " " +
                                            (this.state.openAvatar ? classes.caretActive : "")
                                        }
                                    />
                                }
                                disableTypography={true}
                                className={itemText + " " + classes.userItemText}
                            />
                        </NavLink>
                        <Collapse in={this.state.openAvatar} unmountOnExit>
                            <List className={classes.list + " " + classes.collapseList}>
                                <ListItem className={classes.collapseItem}>
                                    <NavLink
                                        to={`/accounts/${this.props.loggedUserId}/edit_account`}
                                        className={
                                            classes.itemLink + " " + classes.userCollapseLinks
                                        }
                                    >
                                        <span className={collapseItemMini}>
                                            <Icon> <User /></Icon>
                                        </span>
                                        <ListItemText
                                            data-testid="MyAccountButton"
                                            primary={"My Account"}
                                            disableTypography={true}
                                            className={collapseItemText}
                                        />
                                    </NavLink>
                                </ListItem>
                                <ListItem className={classes.collapseItem}>
                                    <NavLink
                                        to="/"
                                        onClick={this.props.exit}
                                        className={
                                            classes.itemLink + " " + classes.userCollapseLinks
                                        }
                                    >
                                        <span className={collapseItemMini}>
                                            <Icon><Logout /></Icon>
                                        </span>
                                        <ListItemText
                                            data-testid="LogoutButton"
                                            primary={"Logout"}
                                            disableTypography={true}
                                            className={collapseItemText}
                                        />
                                    </NavLink>
                                </ListItem>
                            </List>
                        </Collapse>
                    </ListItem>
                </List>
            </div>
        );
        var links = (
            <List className={classes.list}>
                {routes.map((prop, key) => {
                    if (prop.hidden) {
                        return null;
                    }

                    if (prop.redirect) {
                        return null;
                    }
                    if (prop.collapse) {
                        const navLinkClasses =
                            classes.itemLink +
                            " " +
                            cx({
                                [" " + classes.collapseActive]: this.activeRoute(prop.path)
                            });
                        const itemText =
                            classes.itemText +
                            " " +
                            cx({
                                [classes.itemTextMini]:
                                    this.props.miniActive && this.state.miniActive,
                                [classes.itemTextMiniRTL]:
                                    rtlActive && this.props.miniActive && this.state.miniActive,
                                [classes.itemTextRTL]: rtlActive
                            });
                        const collapseItemText =
                            classes.collapseItemText +
                            " " +
                            cx({
                                [classes.collapseItemTextMini]:
                                    this.props.miniActive && this.state.miniActive,
                                [classes.collapseItemTextMiniRTL]:
                                    rtlActive && this.props.miniActive && this.state.miniActive,
                                [classes.collapseItemTextRTL]: rtlActive
                            });
                        const itemIcon =
                            classes.itemIcon +
                            " " +
                            cx({
                                [classes.itemIconRTL]: rtlActive
                            });
                        const caret =
                            classes.caret +
                            " " +
                            cx({
                                [classes.caretRTL]: rtlActive
                            });
                        return (
                            <ListItem
                                className={classes.item}>
                                <NavLink
                                    to={"#"}
                                    className={navLinkClasses}
                                    onClick={() => this.openCollapse(prop.state)}
                                    key={`navlink-${key}`}
                                >
                                    <ListItemIcon className={itemIcon}>
                                        {typeof prop.icon === "string" ? (
                                            <Icon>{prop.icon}</Icon>
                                        ) : (
                                            <prop.icon />
                                        )}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={prop.name}
                                        secondary={
                                            <b
                                                className={
                                                    caret +
                                                    " " +
                                                    (this.state[prop.state] ? classes.caretActive : "")
                                                }
                                            />
                                        }
                                        disableTypography={true}
                                        className={itemText}
                                    />
                                </NavLink>
                                <Collapse in={this.state[prop.state]} unmountOnExit>
                                    <List className={classes.list + " " + classes.collapseList}>
                                        {prop.views.map((prop, key) => {
                                            if (prop.redirect) {
                                                return null;
                                            }
                                            const navLinkClasses =
                                                classes.collapseItemLink +
                                                " " +
                                                cx({
                                                    [" " + classes[color]]: this.activeRoute(prop.path)
                                                });
                                            const collapseItemMini =
                                                classes.collapseItemMini +
                                                " " +
                                                cx({
                                                    [classes.collapseItemMiniRTL]: rtlActive
                                                });
                                            return (
                                                <ListItem className={classes.collapseItem} key={`list-item-${key}`}>
                                                    <NavLink to={prop.name === 'Dashboard' ? `/systems/${systemId}/dashboard` : prop.path} className={navLinkClasses}>
                                                        <span className={collapseItemMini}>
                                                            {prop.mini}
                                                        </span>
                                                        <ListItemText
                                                            primary={prop.name}
                                                            disableTypography={true}
                                                            className={collapseItemText}
                                                        />
                                                    </NavLink>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </Collapse>
                            </ListItem>
                        );
                    }
                    const navLinkClasses =
                        classes.itemLink +
                        " " +
                        cx({
                            [" " + classes[color]]: this.activeRoute(prop.path)
                        });
                    const itemText =
                        classes.itemText +
                        " " +
                        cx({
                            [classes.itemTextMini]:
                                this.props.miniActive && this.state.miniActive,
                            [classes.itemTextMiniRTL]:
                                rtlActive && this.props.miniActive && this.state.miniActive,
                            [classes.itemTextRTL]: rtlActive
                        });
                    const itemIcon =
                        classes.itemIcon +
                        " " +
                        cx({
                            [classes.itemIconRTL]: rtlActive
                        });
                    const path = prop.name === 'Dashboard' ? `/systems/${systemId}/dashboard` : prop.path
                    return (
                        <ListItem className={classes.item} key={`sidebar-item-${key}`}>
                            <NavLink to={path} className={navLinkClasses} data-testid={`Sidebar-icon-${key}`}>
                                <ListItemIcon className={itemIcon}>
                                    {typeof prop.icon === "string" ? (
                                        <Icon>{prop.icon}</Icon>
                                    ) : (
                                        <prop.icon />
                                    )}
                                </ListItemIcon>
                                <ListItemText
                                    primary={prop.name}
                                    disableTypography={true}
                                    className={itemText}
                                />
                            </NavLink>
                        </ListItem>
                    );
                })}
            </List>
        );

        const logoNormal =
            classes.logoNormal +
            " " +
            cx({
                [classes.logoNormalSidebarMini]:
                    this.props.miniActive && this.state.miniActive,
                [classes.logoNormalSidebarMiniRTL]:
                    rtlActive && this.props.miniActive && this.state.miniActive,
                [classes.logoNormalRTL]: rtlActive
            });

        const logoClasses =
            classes.logo +
            " " +
            cx({
                [classes.whiteAfter]: bgColor === "white"
            });

        var brand = (
            <div className={logoClasses}>
                <a href="/systems" className={logoNormal}>
                    <img src={this.props.logoNormal} alt="logo" className={classes.img} />
                </a>
            </div>
        );

        const drawerPaper =
            classes.drawerPaper +
            " " +
            cx({
                [classes.drawerPaperMini]:
                    this.props.miniActive && this.state.miniActive,
                [classes.drawerPaperRTL]: rtlActive
            });
        const sidebarWrapper =
            classes.sidebarWrapper +
            " " +
            cx({
                [classes.drawerPaperMini]:
                    this.props.miniActive && this.state.miniActive
            });
        return (
            <div ref="mainPanel">
                <Hidden
                    mdUp
                    implementation="css"
                >
                    <Drawer
                        variant="temporary"
                        anchor={rtlActive ? "left" : "right"}
                        open={this.props.open}
                        classes={{
                            paper: drawerPaper + " " + classes[bgColor + "Background"]
                        }}
                        onClose={this.props.handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true // Better open performance on mobile.
                        }}
                    >
                        {brand}
                        <SidebarWrapper
                            className={sidebarWrapper}
                            user={user}
                            links={links}
                        />
                        {image !== undefined ? (
                            <div
                                className={classes.background}
                                style={{ backgroundImage: "url(" + image + ")" }}
                            />
                        ) : null}
                    </Drawer>
                </Hidden>
                <Hidden
                    smDown
                    implementation="css"
                >
                    <Drawer
                        onMouseOver={() => this.setState({ miniActive: false })}
                        onMouseOut={() => this.setState({ miniActive: true })}
                        anchor={rtlActive ? "right" : "left"}
                        variant="permanent"
                        open
                        classes={{
                            paper: drawerPaper + " " + classes[bgColor + "Background"]
                        }}
                    >
                        {brand}
                        <SidebarWrapper
                            className={sidebarWrapper}
                            user={user}
                            links={links}
                        />
                        {image !== undefined ? (
                            <div
                                className={classes.background}
                                style={{ backgroundImage: "url(" + image + ")" }}
                            />
                        ) : null}
                    </Drawer>
                </Hidden>
            </div>
        );
    }
}

Sidebar.defaultProps = {
    bgColor: "blue"
};

Sidebar.propTypes = {
    classes: PropTypes.object.isRequired,
    bgColor: PropTypes.oneOf(["white", "black", "blue"]),
    rtlActive: PropTypes.bool,
    color: PropTypes.oneOf([
        "white",
        "red",
        "orange",
        "green",
        "blue",
        "purple",
        "rose"
    ]),
    logo: PropTypes.string,
    logoText: PropTypes.string,
    image: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object)
};

const mapStateToProps = (state) => {
    return {
        username: state.login.username,
        loggedUserId: state.login.loggedUserId,
    }
}
const actions = { exit }

const sidebarWithStyles = withStyles(sidebarStyle)(Sidebar);
export default connect(mapStateToProps, actions)(sidebarWithStyles)